import HubDbasQuizResultsModule from './HubDbasQuizResultsModule'

export default HubDbasQuizResultsModule
